import {
  IGetPhotoRestorationResponse,
  getPhotoRestoration,
} from '@api/requests';
import Logo from '@assets/images/webapp/v2/logo_sign.webp';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const SharePhotoRecoveryPage = () => {
  const [searchParams] = useSearchParams();
  const restorationId = searchParams.get('id');

  const [restorationData, setRestorationData] =
    useState<IGetPhotoRestorationResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRestoration = async () => {
      if (!restorationId) {
        setError('No restoration ID found');
        setLoading(false);
        return;
      }

      try {
        const res = await getPhotoRestoration({
          restoration_id: restorationId,
        });
        setRestorationData(res.data);
      } catch (err: any) {
        console.error(err);
        setError(err?.response?.data?.message ?? 'Failed to fetch restoration');
      } finally {
        setLoading(false);
      }
    };

    fetchRestoration();
  }, []);

  return (
    <div
      style={{
        padding: 20,
        textAlign: 'center',
        background: '#F5F5F5',
        height: '100dvh',
      }}
    >
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        margin={'17px 0 12px'}
        padding={'0 20px'}
        gap="6px"
      >
        <img width={'32px'} src={Logo} alt="logo" />
        <Typography
          variant="h1"
          sx={{
            fontFamily: 'Outfit600',
            color: '#040B1D',
            fontSize: '16px',
          }}
        >
          Mytraits
        </Typography>
      </Box>

      {restorationData && (
        <div
          style={{
            width: '100%',
            maxWidth: 353,
            margin: '32px auto 0',
          }}
        >
          {/* <TopMatchCard report={shareReportData} /> */}
          <img
            src={restorationData?.restorations?.[0]?.restored_image_url}
            alt="restored photo"
          />
        </div>
      )}
    </div>
  );
};

export default SharePhotoRecoveryPage;
